import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import InitialLoader from '../Components/InitialLoader';
import PopUpAcknowledgement from '../Components/PopUpAcknowledgement';
import ChatIntro from './ChatIntro';

const Welcome = observer((props) => {
  const [isSetup, setIsSetup] = useState(false);
  const [acknowledgePopup, setAcknowledgePop] = useState(false);

  useEffect(() => {
    setIsSetup(true);
    // eslint-disable-next-line
  }, [props.store.SessionStore.isSetup]);

  function acknowledge (){
    console.log("acknowledge");
    setAcknowledgePop(true);
  }


  return (
    <>
      {!acknowledgePopup ? (
        <PopUpAcknowledgement {...props} acknowledge={acknowledge} />
      ) : (
        <>
          {!isSetup ? (<InitialLoader {...props} />) : (<ChatIntro {...props} />)}
        </>
      )}
    </>
  );
});

export default Welcome;